<template>
  <div class="wrapper">
    <div class="container-fluid expandHeight">
      <div class="row expandHeight">
        <div class="col-md-9 access-left-side">
          <img
            class="logo-img"
            alt="logo"
            src="../assets/images/logo-rever-white.svg"
          />
          <div class="login-copy-head">
            {{ $t('auth.access.front_line_innovation_fuel') }}
          </div>
          <div class="login-copy-title">
            {{
              $t(
                'auth.access.your_space_for_capturing_and_executing_ideas_as_a_team'
              )
            }}
          </div>
          <div class="login-copy-subtitle">
            {{ $t('download.lets_make_things_better') }}
          </div>

          <div class="download-icons">
            <div class="download-icon" v-if="deviceType === 'ios'">
              <a
                href="https://itunes.apple.com/app/rever-score/id1114875070?l=en&mt=8"
              >
                <img src="../assets/images/download_apple.png" alt="apple" />
              </a>
            </div>
            <div class="download-icon" v-if="deviceType === 'android'">
              <a
                href="https://play.google.com/store/apps/details?id=com.reverscore.mobileapp"
              >
                <img
                  src="../assets/images/download_android.png"
                  alt="android"
                />
              </a>
            </div>
          </div>

          <div class="contact">
            <a href="mailto:support@reverscore.com">{{
              $t('download.contact')
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UAParser from 'ua-parser-js'

export default {
  data: function() {
    return {
      deviceType: null,
    }
  },

  created: function() {
    const parser = new UAParser()
    const agent = parser.getResult()

    if (agent.device.type === 'mobile' || agent.device.type === 'tablet') {
      if (agent.device.vendor === 'Apple') {
        this.deviceType = 'ios'
      } else {
        this.deviceType = 'android'
      }
    }
  },
}
</script>

<style lang="scss" scoped>
html,
body {
  height: 100%;
}

body {
  min-height: 100%;
}

.expandHeight {
  height: 100%;
}

.quoteOfTheDay {
  font-size: $font-size-16;
  font-weight: 600;
  font-style: italic;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  color: $color-blue-darken1;
  quotes: '“' '”' '‘' '’';
}

.quoteOfTheDay:before {
  content: open-quote;
}

.quoteOfTheDay:after {
  content: close-quote;
}

.quoteAuthor {
  font-size: $font-size-14;
  letter-spacing: -0.3px;
  color: $color-blue-darken1;
}

.wrapper {
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  margin: 0px;
  background-position: center;
  background-size: cover;
  overflow: auto;
  height: 100%;
  width: 100%;
}

.access-left-side {
  height: 100%;
  background-color: #0f3868;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 75px;
}

#login-form {
  margin-top: 50px;
}

.login-copy-head {
  color: $color-white;
  text-transform: uppercase;
  font-size: $font-size-14;
  letter-spacing: 2px;
  width: 80%;
  padding-left: 15px;
}

.login-copy-title {
  padding-top: 20px;
  color: $color-white;
  text-transform: uppercase;
  font-size: 24px;
  padding-left: 15px;
}

.login-copy-subtitle {
  padding-top: 30px;
  width: 60%;
  color: $color-white;
  font-size: $font-size-16;
  font-style: italic;
  padding-left: 15px;
}

.login-message {
  color: $color-blue-darken1;
  font-weight: 300;
  font-size: 36px;
}

.logo {
  margin: 20px auto 40px;
  margin-top: 0;
}

.logo-img {
  width: 50%;
  margin: 10px 10px 50px;
  margin-top: 0;
  display: block;
}

.login {
  padding-bottom: 30px;
  margin: auto;
  margin-top: 100px;
  text-align: center;
  font-size: 15px;
}

.login-img {
  margin: 20px 0px 40px -30px;
}

input#email,
input#password {
  padding: 0;
  border-top: none;
  background: none;
  box-shadow: none;
  border-right: none;
  border-left: none;
  font-size: 16px;
  color: $color-blue-grey-darken2;
  border-radius: 0;
}

label {
  color: $color-blue-grey-darken2;
  font-size: 16px;
}

.forgotPassword {
  margin-top: 10px;
  font-size: 11px;
  text-align: center;
  color: $color-blue-darken1;
}

.resetPassword {
  margin-left: 5px;
  font-size: 11px;
  color: #26a3ef;
  font-weight: 400;
  text-decoration: underline;
}

.validation-message {
  margin: 0;
  padding: 0;
  color: $color-red;
  font-size: 14px;
}

.download-icons {
  margin: 40px auto 0;
  text-align: center;
}

.download-icon {
  margin-bottom: 10px;
}

.contact {
  margin-top: 50px;
  text-align: center;
  font-size: 11px;
  margin-bottom: 50px;

  a {
    color: $color-white;
  }
}
</style>
